















import { Component, Prop, Vue } from "vue-property-decorator";
import gql from "graphql-tag";
import NoData from "@/basics/boxes/NoData.vue";
import RoomsListComponent, { Room } from "@/components/list/RoomsList.vue";
@Component({
  apollo: {
    rooms: {
      query: gql`
        query($id: String!) {
          building(id: $id) {
            id
            roomFeed(count: 999, page: 1) {
              rooms {
                id
                name
                group {
                  id
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.buildingId
        };
      },
      update(data: any) {
        return data.building.roomFeed.rooms;
      }
    }
  },
  components: { NoData, RoomsListComponent }
})
export default class RoomList extends Vue {
  @Prop({ type: String, required: true }) buildingId!: string;
  @Prop({ type: String, required: true }) buildingGroupId!: string;
  rooms: Room[] = [];
  get loading(): boolean {
    return this.$apollo.loading;
  }
}
